import { queryOptions } from '@tanstack/react-query';

import { backendApis } from '@/backendApis';

import {
  HivemindChatResponseSchema,
  HivemindGroupsResponseSchema,
  type HivemindGroup,
} from './hivemind.types';

const HIVEMIND_KEY = ['hivemind'] as const;

export const hivemindChatQueryKey = (chatId: string) =>
  [...HIVEMIND_KEY, 'threads', 'by-chat', chatId] as const;

export const hivemindChatQueryOptions = (chatId: string) =>
  queryOptions({
    queryKey: hivemindChatQueryKey(chatId),
    // The signal stops the API client's own retries of a superseded read
    queryFn: async ({ signal }) => {
      const data = await backendApis.hive.getThreadByChat(chatId, signal);
      return HivemindChatResponseSchema.parse(data);
    },
    refetchOnWindowFocus: true,
  });

export const hivemindGroupsQueryOptions = () =>
  queryOptions({
    queryKey: [...HIVEMIND_KEY, 'groups'] as const,
    queryFn: async ({ signal }): Promise<HivemindGroup[]> =>
      HivemindGroupsResponseSchema.parse(
        await backendApis.hive.getGroups(signal)
      ).groups,
  });
